import type { ErrorMessage } from '@/core/api/error-messages';

export const COUNTRY_ERRORS: Record<string, ErrorMessage> = {
  'Country.NotFound': {
    title: 'País no encontrado',
    message: 'El país solicitado no existe.',
    severity: 'error',
  },
  'Country.CountryCodeRequired': {
    title: 'Código ISO requerido',
    message: 'El código ISO es obligatorio.',
    severity: 'error',
  },
  'Country.CountryCodeInvalidFormat': {
    title: 'Código ISO inválido',
    message: 'El código ISO debe tener 2 letras.',
    severity: 'error',
  },
  'Country.CountryCodeAlreadyExists': {
    title: 'Código ISO duplicado',
    message: 'El código ISO ya se encuentra registrado.',
    severity: 'error',
  },
  'Country.OfficialNameRequired': {
    title: 'Nombre oficial requerido',
    message: 'El nombre oficial es obligatorio.',
    severity: 'error',
  },
  'Country.OfficialNameTooShort': {
    title: 'Nombre oficial muy corto',
    message: 'El nombre oficial debe tener al menos 2 caracteres.',
    severity: 'error',
  },
  'Country.OfficialNameTooLong': {
    title: 'Nombre oficial muy largo',
    message: 'El nombre oficial no puede exceder 150 caracteres.',
    severity: 'error',
  },
  'Country.OfficialNameAlreadyExists': {
    title: 'Nombre oficial duplicado',
    message: 'El nombre oficial ya se encuentra registrado en tu cuenta.',
    severity: 'error',
  },
  'Country.CommonNameRequired': {
    title: 'Nombre común requerido',
    message: 'El nombre común es obligatorio.',
    severity: 'error',
  },
  'Country.CommonNameTooShort': {
    title: 'Nombre común muy corto',
    message: 'El nombre común debe tener al menos 2 caracteres.',
    severity: 'error',
  },
  'Country.CommonNameTooLong': {
    title: 'Nombre común muy largo',
    message: 'El nombre común no puede exceder 100 caracteres.',
    severity: 'error',
  },
  'Country.CommonNameAlreadyExists': {
    title: 'Nombre común duplicado',
    message: 'El nombre común ya se encuentra registrado.',
    severity: 'error',
  },
  'Country.CurrencyRequired': {
    title: 'Moneda requerida',
    message: 'La moneda base es obligatoria.',
    severity: 'error',
  },
  'Country.CurrencyInvalid': {
    title: 'Moneda inválida',
    message: 'La moneda seleccionada no es válida.',
    severity: 'error',
  },
  'Country.NotSpanishSpeaking': {
    title: 'País no permitido',
    message: 'Solo se permiten registrar países de habla hispana.',
    severity: 'error',
  },
  'Country.CountryMustBeDisabled': {
    title: 'País activo',
    message: 'Debe deshabilitarse antes de eliminar.',
    severity: 'error',
  },
  'Country.CountryHasActiveDependencies': {
    title: 'País con dependencias',
    message: 'No se puede eliminar este país debido a dependencias activas.',
    severity: 'error',
  },
  'Country.ParentRequired': {
    title: 'Padre requerido',
    message: 'El parentesco es obligatorio para este nivel territorial.',
    severity: 'error',
  },
  'Country.CannotSetParentToPais': {
    title: 'Jerarquía inválida',
    message: 'Un país no puede tener padre.',
    severity: 'error',
  },
  'Country.InvalidParentLevel': {
    title: 'Nivel de padre inválido',
    message: 'El padre no es del nivel territorial correcto.',
    severity: 'error',
  },
  'Country.CannotDeleteWithChildren': {
    title: 'País con hijos activos',
    message: 'No se puede eliminar porque tiene hijos activos.',
    severity: 'error',
  },
  'Country.InvalidParentId': {
    title: 'ID de padre inválido',
    message: 'El ID del padre debe ser un número válido.',
    severity: 'error',
  },
  'Country.CountryNotAPais': {
    title: 'Nivel territorial inválido',
    message: 'El registro seleccionado no tiene el nivel territorial "País".',
    severity: 'error',
  },
  'Country.ParentInactive': {
    title: 'País padre inactivo',
    message: 'Debe habilitarse el país padre antes de habilitar este registro.',
    severity: 'error',
  },
  'Country.CurrencyInUse': {
    title: 'Moneda en uso',
    message: 'No se puede cambiar la moneda porque existen dependencias activas.',
    severity: 'error',
  },
};
